import React, { FC } from 'react';

export const DownArrowIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      d="M11.06 5.53003L8 8.58336L4.94 5.53003L4 6.47003L8 10.47L12 6.47003L11.06 5.53003Z"
      fill="currentColor"
    />
  </svg>
);
